<template>
  <!-- Modal -->
  <div :id="id" class="modal fade isco-selector" tabindex="-1" role="dialog" aria-labelledby="iscoModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 id="exampleModalLongTitle" class="modal-title">{{ $t('isco_selector.choose_an_occupation') }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ISCOSelector ref="isco" :read-only="false" @valid="isValid" />
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close()">{{ $t('close') }}</button>
          <button :disabled="!valid" type="button" class="btn btn-primary" @click.prevent="save()">{{ $t('save') }}</button>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
.btn.dropdown-toggle {
  max-width: 100%;
  overflow: auto;
  text-overflow: ellipsis;
}
</style>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'ISCOSelectorModal',

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    valid: false
  }),

  computed: {
    occupation () {
      return this.$refs.isco.occupation
    }
  },

  methods: {
    close () {
      this.$emit('closed')
    },

    isValid (valid) {
      this.valid = valid
    },

    save () {
      if (this.occupation != '') {
        this.$emit('saved', this.$refs.isco.occupation)
        $('#' + this.id).modal('hide')
      }

      this.close()
    },

    select (occupation) {
      this.$refs.isco.setOccupation(occupation)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ISCOSelectorModal.vue